import { useTheme } from "@mui/material";
import {
  PageChangeEvent,
  RenderPage,
  ScrollMode,
  Viewer,
  Worker,
} from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { HighlightArea } from "@react-pdf-viewer/highlight";
import "@react-pdf-viewer/toolbar/lib/styles/index.css";
import React, { useEffect } from "react";
import "./PDFViewer.css";

type HighlightsType = {
  id: number;
  image: string;
  selectionRegion: HighlightArea;
}[];

interface PDFViewerProps {
  pdfFile: string;
  onPageChangeCallback?: (e: PageChangeEvent) => void;
  highlightSelectionPlugin?: Plugin;
  highlightPlugin?: any;
  previousHighlights?: Array<any>;
  highlights?: HighlightsType;
  customRenderPage?: RenderPage;
}

export const PDFViewer: React.FC<PDFViewerProps> = ({
  pdfFile,
  onPageChangeCallback,
  highlightSelectionPlugin,
  highlightPlugin,
  previousHighlights,
  highlights,
  customRenderPage,
}) => {
  const theme = useTheme();

  const viewerTheme = theme.palette.mode === "dark" ? "dark" : "light";

  const [currentPDFPage, setCurrentPDFPage] = React.useState<number | null>(
    null
  );

  // get the current page number for the PDF viewer from the context
  useEffect(() => {
    if (setCurrentPDFPage) {
      setCurrentPDFPage(currentPDFPage ?? 1);
    }
    console.log(`Current page: ${currentPDFPage} from PDFViewer.tsx`);
  }, [currentPDFPage, setCurrentPDFPage]);

  const newplugin = defaultLayoutPlugin();
  const { jumpToHighlightArea } = highlightPlugin;
  console.log("my previous highlights", previousHighlights);

  return (
    <div>
      <h2>View PDF</h2>
      <div className='pdf-container'>
        <Worker workerUrl='/assets/pdf.worker.min.js'>
          {pdfFile ? (
            <div
              style={{
                border: "1px solid rgba(0, 0, 0, 0.3)",
                display: "flex",
                height: "100%",
                overflow: "hidden",
              }}
            >
              {highlights && highlights.length > 0 && (
                <div
                  style={{
                    borderRight: "1px solid rgba(0, 0, 0, 0.3)",
                    width: "25%",
                    overflow: "auto",
                  }}
                >
                  {highlights.map((highlight) => {
                    return (
                      <div
                        key={highlight.id}
                        onClick={() => {
                          console.log(
                            "highlight.selectionRegion",
                            highlight.selectionRegion
                          );
                          jumpToHighlightArea(highlight.selectionRegion);
                        }}
                      >
                        {highlight.image && (
                          <img
                            src={highlight.image}
                            alt='thumbnail'
                            width='100%'
                          />
                        )}

                        <button>Highlight #{highlight.id}</button>
                      </div>
                    );
                  })}
                </div>
              )}
              <div
                style={
                  highlights
                    ? {
                        flex: "1 1 0",
                      }
                    : {}
                }
              >
                <Viewer
                  fileUrl={pdfFile}
                  plugins={[
                    newplugin,
                    highlightPlugin ?? {},
                    highlightSelectionPlugin ?? {},
                  ]}
                  scrollMode={ScrollMode.Page}
                  onPageChange={onPageChangeCallback}
                  renderPage={customRenderPage ?? undefined}
                  theme={viewerTheme}
                />
              </div>
            </div>
          ) : (
            <p>Please select a file</p>
          )}
        </Worker>
      </div>
    </div>
  );
};
